import { ResolverTag } from '@ps/web-core-enums';
import React from 'react';

import ResolverLink from '@swf/components/ResolverLink/ResolverLink';
import Translation from '@swf/components/Translation/Translation';
import { Icon } from '@swf/sports/components';

import {
  TXTWCL_A_N0_Rule_4_deduction_has_been_ELL,
  TXTWCL_A_dead_heat_deduction_has_been_ELL,
  TXTWCL_More_info
} from './BetDeduction.messages.json';
import styles from './BetDeduction.scss';

type DeductionType = 'rule4' | 'deadHeatWin' | 'deadHeatEachway';

const deductionTypeMessages: Record<
  DeductionType,
  (value?: React.ReactElement) => React.ReactElement
> = {
  rule4: (value) => (
    <>
      <Translation {...TXTWCL_A_N0_Rule_4_deduction_has_been_ELL} values={{ 0: value }} />
      &nbsp;
      <ResolverLink resolverTag={ResolverTag.HorseRacingRules}>
        <Translation {...TXTWCL_More_info} />
      </ResolverLink>
    </>
  ),
  deadHeatWin: () => <Translation {...TXTWCL_A_dead_heat_deduction_has_been_ELL} />,
  deadHeatEachway: () => <Translation {...TXTWCL_A_dead_heat_deduction_has_been_ELL} />
};

const BetDeduction: React.FC<{ type: DeductionType; value?: React.ReactElement }> = ({
  type,
  value
}) => (
  <div className={styles.content}>
    <Icon name="info" className={styles.icon} size="xl" />
    <span className={styles.deductionMessage}>{deductionTypeMessages[type](value)}</span>
  </div>
);

export default BetDeduction;
